import { CommonModule } from '@angular/common';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';

import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FilterPipe } from './pipe/filter.pipe';
import { FormErrorsComponent } from './components/form-errors/form-errors.component';

@NgModule({
    declarations: [
      FilterPipe,
      FormErrorsComponent,
    ],
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MatTableModule,
      MatSortModule,
      MatPaginatorModule,
      NgbModule,
      NgxUiLoaderModule,
    ],
    exports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MatTableModule,
      MatSortModule,
      MatPaginatorModule,
      FilterPipe,
      FormErrorsComponent,
      NgxUiLoaderModule,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class SharedModule {}
